module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/62.1473d2c0.png";